import { Spinner } from "react-bootstrap";

export const LoadingCard = () => (
  <div className="text-center py-5 bg-white rounded-3 shadow-sm">
    <Spinner animation="border" variant="primary" />
  </div>
);
